import { ICrudGenericFields } from 'models/CrudInterface'

export const treasuryAccountsValidationRulesLevelsFormFields: Array<ICrudGenericFields> =
	[
		// Array de los campos de la tab
		{
			id: 'cod_val', // Id del campo en SQL
			type: 'text', // Tipo de campo
			width: 'col-sm-2', // Ancho del campo
			height: '', // Ancho de la columna donde entra el campo
			default: null, // Valor por defecto
			maxChars: 10, // Limitación de caracteres
			autoComplete: 'new-off', // Si permite autocompletar
			disabled: false, // Booleano para desabilitar
			comboData: '', // Nombre del store para tomar los datos del dropdown
			dependsOn: {
				// Si depende de otro campo, rellenar aca
				id: '', // Id del campo de que depende
				values: [
					{
						idValue: '', // Valor de que depende
						disabled: false // Si el valor es igual al declarado, se desabilita/habilita
					}
				]
			}
		},
		{
			id: 'nivel', // Id del campo en SQL
			type: 'text', // Tipo de campo
			width: 'col-sm-2', // Ancho del campo
			height: '', // Ancho de la columna donde entra el campo
			default: null, // Valor por defecto
			maxChars: 4, // Limitación de caracteres
			autoComplete: 'new-off', // Si permite autocompletar
			disabled: false, // Booleano para desabilitar
			comboData: 'valueTreasuryLevels', // Nombre del store para tomar los datos del dropdown
			dependsOn: {
				// Si depende de otro campo, rellenar aca
				id: '', // Id del campo de que depende
				values: [
					{
						idValue: '', // Valor de que depende
						disabled: false // Si el valor es igual al declarado, se desabilita/habilita
					}
				]
			}
		},
		{
			id: 'nombre_niv', // Id del campo en SQL
			type: 'text', // Tipo de campo
			width: 'col-sm-2', // Ancho del campo
			height: '', // Ancho de la columna donde entra el campo
			default: null, // Valor por defecto
			maxChars: 15, // Limitación de caracteres
			autoComplete: 'new-off', // Si permite autocompletar
			disabled: false, // Booleano para desabilitar
			comboData: '', // Nombre del store para tomar los datos del dropdown
			dependsOn: {
				// Si depende de otro campo, rellenar aca
				id: '', // Id del campo de que depende
				values: [
					{
						idValue: '', // Valor de que depende
						disabled: false // Si el valor es igual al declarado, se desabilita/habilita
					}
				]
			}
		},
		{
			id: 'cant_dig', // Id del campo en SQL
			type: 'text', // Tipo de campo
			width: 'col-sm-2', // Ancho del campo
			height: '', // Ancho de la columna donde entra el campo
			default: null, // Valor por defecto
			maxChars: 1, // Limitación de caracteres
			autoComplete: 'new-off', // Si permite autocompletar
			disabled: false, // Booleano para desabilitar
			comboData: '', // Nombre del store para tomar los datos del dropdown
			dependsOn: {
				// Si depende de otro campo, rellenar aca
				id: '', // Id del campo de que depende
				values: [
					{
						idValue: '', // Valor de que depende
						disabled: false // Si el valor es igual al declarado, se desabilita/habilita
					}
				]
			}
		},
		{
			id: 'tipo_dato', // Id del campo en SQL
			type: 'combo', // Tipo de campo
			width: 'col-sm-2', // Ancho del campo
			height: '', // Ancho de la columna donde entra el campo
			default: null, // Valor por defecto
			maxChars: 1, // Limitación de caracteres
			autoComplete: 'new-off', // Si permite autocompletar
			disabled: false, // Booleano para desabilitar
			comboData: 'dataType', // Nombre del store para tomar los datos del dropdown
			dependsOn: {
				// Si depende de otro campo, rellenar aca
				id: '', // Id del campo de que depende
				values: [
					{
						idValue: '', // Valor de que depende
						disabled: false // Si el valor es igual al declarado, se desabilita/habilita
					}
				]
			}
		},
		{
			id: 'tipo_val', // Id del campo en SQL
			type: 'combo', // Tipo de campo
			width: 'col-sm-2', // Ancho del campo
			height: '', // Ancho de la columna donde entra el campo
			default: null, // Valor por defecto
			maxChars: 1, // Limitación de caracteres
			autoComplete: 'new-off', // Si permite autocompletar
			disabled: false, // Booleano para desabilitar
			comboData: 'validationType', // Nombre del store para tomar los datos del dropdown
			dependsOn: {
				// Si depende de otro campo, rellenar aca
				id: '', // Id del campo de que depende
				values: [
					{
						idValue: '', // Valor de que depende
						disabled: false // Si el valor es igual al declarado, se desabilita/habilita
					}
				]
			}
		},
		{
			id: 'desde', // Id del campo en SQL
			type: 'text', // Tipo de campo
			width: 'col-sm-2', // Ancho del campo
			height: '', // Ancho de la columna donde entra el campo
			default: null, // Valor por defecto
			maxChars: 20, // Limitación de caracteres
			autoComplete: 'new-off', // Si permite autocompletar
			disabled: false, // Booleano para desabilitar
			comboData: '', // Nombre del store para tomar los datos del dropdown
			dependsOn: {
				// Si depende de otro campo, rellenar aca
				id: '', // Id del campo de que depende
				values: [
					{
						idValue: '', // Valor de que depende
						disabled: false // Si el valor es igual al declarado, se desabilita/habilita
					}
				]
			}
		},
		{
			id: 'hasta', // Id del campo en SQL
			type: 'text', // Tipo de campo
			width: 'col-sm-2', // Ancho del campo
			height: '', // Ancho de la columna donde entra el campo
			default: null, // Valor por defecto
			maxChars: 20, // Limitación de caracteres
			autoComplete: 'new-off', // Si permite autocompletar
			disabled: false, // Booleano para desabilitar
			comboData: '', // Nombre del store para tomar los datos del dropdown
			dependsOn: {
				// Si depende de otro campo, rellenar aca
				id: '', // Id del campo de que depende
				values: [
					{
						idValue: '', // Valor de que depende
						disabled: false // Si el valor es igual al declarado, se desabilita/habilita
					}
				]
			}
		},
		{
			id: 'tipo_alinea', // Id del campo en SQL
			type: 'combo', // Tipo de campo
			width: 'col-sm-2', // Ancho del campo
			height: '', // Ancho de la columna donde entra el campo
			default: null, // Valor por defecto
			maxChars: 1, // Limitación de caracteres
			autoComplete: 'new-off', // Si permite autocompletar
			disabled: false, // Booleano para desabilitar
			comboData: 'alignmentType', // Nombre del store para tomar los datos del dropdown
			dependsOn: {
				// Si depende de otro campo, rellenar aca
				id: '', // Id del campo de que depende
				values: [
					{
						idValue: '', // Valor de que depende
						disabled: false // Si el valor es igual al declarado, se desabilita/habilita
					}
				]
			}
		},
		{
			id: 'relleno', // Id del campo en SQL
			type: 'text', // Tipo de campo
			width: 'col-sm-2', // Ancho del campo
			height: '', // Ancho de la columna donde entra el campo
			default: null, // Valor por defecto
			maxChars: 1, // Limitación de caracteres
			autoComplete: 'new-off', // Si permite autocompletar
			disabled: false, // Booleano para desabilitar
			comboData: '', // Nombre del store para tomar los datos del dropdown
			dependsOn: {
				// Si depende de otro campo, rellenar aca
				id: '', // Id del campo de que depende
				values: [
					{
						idValue: '', // Valor de que depende
						disabled: false // Si el valor es igual al declarado, se desabilita/habilita
					}
				]
			}
		}
	]
